__turbopack_context__.v({
  "mediaRoot": "mediacontainer-module-scss-module__gIcTKq__mediaRoot",
});
